export default {
  title: 'E-Leave',
  'acting-for': {
    label: 'Acting for',
    self: 'Myself',
    'missing-request-permission':
      'You do not have permission to request leave. Please contact an administrator to add LEAVE_REQ.',
    'missing-approve-permission':
      'You do not have permission to approve leave. Please contact an administrator to add LEAVE_APP.'
  },
  tabs: {
    'my-leave': 'My Leave',
    history: 'Transaction History Status',
    approve: 'Leave Approve',
    'approver-calendar': 'Approve Calendar'
  },
  'my-leave': {
    'loading-state': {
      loading: 'Updating data…',
      entitlementFailed:
        'Unable to update entitlement. Previously displayed balances have not been refreshed.',
      calendarFailed:
        'Unable to update the calendar. Previously displayed events have not been refreshed.',
      retry: 'Try again'
    },
    buttons: {
      report: 'REPORT',
      approval: 'APPROVAL',
      calendar: 'APPROVE CALENDAR',
      delegate: 'DELEGATE',
      request: 'REQUEST'
    },
    'my-entitlement-form': {
      title: 'My Entitlement',
      'entitlement-type': {
        annualLeave: 'Annual Leave',
        carryForward: 'Carry Forward',
        sickLeave: 'Sick Leave',
        businessLeave: 'Business Leave',
        otherLeave: 'Other Leave'
      },
      words: {
        total: 'Total',
        days: 'Days',
        entitlement: 'Entitlement',
        used: 'Used',
        balance: 'Balance',
        pending: 'Pending'
      }
    },
    'my-leave-form': {
      title: 'My Leave',
      'half-day-morning': 'Morning',
      'half-day-afternoon': 'Afternoon',
      hourly: 'Hourly'
    },
    'leave-request-form': {
      dates: {
        selectLeaveType:
          'Please select an available leave type for this employee.',
        loading: 'Loading leave rules and employee shift calendar…',
        scheduleMissing:
          'Employee shift calendar data is missing or conflicting. Please contact HR.',
        birthdayMissing:
          'The required birthday information is missing. Please ask HR to update the employee or family record.',
        birthdayMonth:
          'The entire request must stay in one eligible birthday month.',
        periodYear: 'Select dates within the year of this leave entitlement.',
        invalidDate: 'Please check the start and end dates.',
        blockLeaveUnavailable:
          'The selected range does not qualify for block leave. Adjust the dates or clear Block Leave.',
        restrictedDate:
          'The selected dates do not meet the leave scheduling rules.',
        emptyCharge:
          'The request must include leave time counted under this leave policy.',
        invalidLimits:
          'The working hours or request limit is invalid. Please contact HR.',
        maxPerRequest:
          'The counted leave exceeds the maximum allowed per request.'
      },
      approvers: {
        loading: 'Loading approvers…',
        failed: 'Unable to load approvers. Please try again.'
      },
      hour: {
        nextDay: 'Ends the next day: {{date}}',
        equalTime: 'Start and end times must be different',
        crossYear: 'Hour leave cannot cross a year boundary',
        incomplete: 'Select a leave type, date and both times',
        loading: 'Calculating leave time…',
        charged: 'Deducted: {{minutes}} minutes',
        details:
          'Duration {{gross}} − break {{rest}} = net {{net}} minutes; continuity adjustment +{{adjustment}} minute(s)',
        remaining:
          'Remaining in this shift after this request: {{minutes}} minutes'
      },
      titles: {
        add: 'Add New Leave Request',
        view: 'Preview Leave Request',
        edit: 'Edit Leave Request'
      },
      words: {
        requester: 'Requester',
        'agent-requester': 'Agent Request',
        days: 'Days',
        total: 'Total',
        selectDate: 'Select Date',
        selectTime: 'Select Time'
      },
      fields: {
        leaveType: 'Leave Type',
        leavePeriod: 'Leave Period',
        emergencyLeave: '',
        emergencyLeaveLabel: 'Emergency leave',
        fromDate: 'From Date',
        toDate: 'To Date',
        startTime: 'Start Time',
        endTime: 'End Time',
        leaveReason: 'Leave Reason',
        reason: 'Reason',
        attachFile: 'Attach File (limit 3 files & Not Duplicate)',
        approver: 'Approver',
        status: 'Status',
        'request-status': 'Request Status',
        'please-upload-file': 'Please upload file',
        'employees-name': 'Employee Name',
        'hr-admin-name': 'HR Admin Name',
        'over-date': 'To date must be after from date',
        'over-time': 'End time must be after time date',
        blockLeave: '',
        blockLeaveLabel: 'Block Leave'
      },
      buttons: {
        submit: 'SUBMIT',
        cancel: 'CANCEL'
      },
      'error-message': {
        '001': `Save failed. Because leave request date is between the year.`
      }
    }
  },
  history: {
    'filter-form': {
      organization: {
        placeholder: 'Oc Name..',
        label: 'Oc Name'
      },
      'employee-code': {
        placeholder: 'Employee Code..',
        label: 'Employee Code'
      },
      'name-surname': {
        placeholder: 'Name - Surname..',
        label: 'Name - Surname'
      },
      position: {
        placeholder: 'Position..',
        label: 'Position'
      },
      level: {
        placeholder: 'Level..',
        label: 'Level'
      },
      status: {
        placeholder: 'Status..',
        label: 'Status'
      },
      'leave-status': {
        placeholder: 'Leave Status..',
        label: 'Leave Status'
      },
      date: {
        placeholder: 'Date..',
        label: 'Date',
        dateRange: {
          placeholder: {
            formDate: 'From Date',
            toDate: 'To Date'
          }
        }
      },
      'leave-type': {
        placeholder: 'Select All',
        label: 'Leave Type'
      }
    },
    table: {
      name: 'Name - Surname',
      type: 'Leave Type',
      duration: 'Leave Duration',
      days: 'No. of Days',
      status: 'Status',
      approval: 'Apporval Persons',
      attach: 'Attach',
      action: 'Action'
    },
    modal: {
      cancelFailed: 'Unable to cancel the leave request. Please try again.',
      cancel: 'Are you sure want to cancel ?',
      resent: 'Do you want to Resent Email ?',
      buttons: {
        yes: 'Yes',
        no: 'No'
      }
    }
  }
}
